import { FacetCategories } from "../FacetCategories";
import FacetViewModel from "./FacetViewModel";

export default class FacetCategoryViewModel {
  public id: number;
  public name: string;
  public systemName: FacetCategories;
  public maxActiveCount: number;
  public facets: FacetViewModel[] = [];
}
